export const picture = { cursor: 'pointer' }
